import React from "react";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";

const AgencyList = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Agency List</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiSearchSelect
                          placeholder={"Agency Name"}
                          label="Agency Name"
                          options={[]}
                          onChange={function (
                            value: string,
                            id: string,
                            data: any
                          ): void {
                            throw new Error("Function not implemented.");
                          }}
                          value={""}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Get"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AgencyList;
